export const messages = {
    zh: {
        statisticsManage: {
            queryConditions: '查询条件',
            search: '查询',
            reset: '重置',
            statisticsData: '统计数据',
            paidRepairStatistics: '有偿维修统计',
            selfRepairMaterialStatistics: '自行修理物资统计',
            startDate: '开始日期',
            endDate: '结束日期',
            selectRepairPart: '请选择报修部位',
            selectOrderType: '请选择工单类型',
            indoorRepair: '室内报修',
            publicAreaRepair: '公区报修',
            repairPart: '报修部位',
            orderType: '工单类型',
            totalCount: '工单总数',
            pendingCount: '待处理',
            processingCount: '处理中',
            completedCount: '已完成',
            cancelledCount: '已取消'
        }
    },
    en: {
        statisticsManage: {
            queryConditions: 'Query Conditions',
            search: 'Search',
            reset: 'Reset',
            statisticsData: 'Statistics Data',
            paidRepairStatistics: 'Paid Repair Statistics',
            selfRepairMaterialStatistics: 'Self Repair Material Statistics',
            startDate: 'Start Date',
            endDate: 'End Date',
            selectRepairPart: 'Select Repair Part',
            selectOrderType: 'Select Order Type',
            indoorRepair: 'Indoor Repair',
            publicAreaRepair: 'Public Area Repair',
            repairPart: 'Repair Part',
            orderType: 'Order Type',
            totalCount: 'Total Count',
            pendingCount: 'Pending',
            processingCount: 'Processing',
            completedCount: 'Completed',
            cancelledCount: 'Cancelled'
        }
    }
}
